<template>
  <div>
    <el-breadcrumb style="margin: 0 0 20px 10px" separator="/">
      <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>仓库管理</el-breadcrumb-item>
      <el-breadcrumb-item>库位盘点</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content">
      <!-- <div class="tt">危废管理</div>
      <div class="xian"></div> -->
      <div class="list_box">
        <div class="tt1">盘点列表</div>
        <div>
          <el-button type="add" icon="el-icon-circle-plus-outline" @click="add"
            >添加</el-button
          >
        </div>
      </div>
      <div class="int_box">
        <div class="int_box11">
          <span>库位名称：</span>
          <el-input
            class="int_width"
            v-model="name"
            placeholder="请输入库位名称"
            clearable
          ></el-input>
        </div>
        <div class="int_box11">
          <span>产品名称：</span>
          <el-input
            class="int_width"
            v-model="product_name"
            placeholder="请输入产品名称"
            clearable
          ></el-input>
          <el-button
            style="margin-left: 50px"
            type="cha"
            icon="el-icon-search"
            @click="chaxun"
            >查询</el-button
          >
        </div>
      </div>
      <template>
        <el-table
          :header-cell-style="tableHeader"
          :data="userList"
          style="width: 100%"
          stripe
        >
          <el-table-column
            width="166px"
            align="center"
            prop="ware_name"
            label="库位名称"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="product_name"
            label="产品名称"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="should_residue"
            label="应剩余"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="real_residue"
            label="实剩余"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="admin_id"
            label="操作人"
          ></el-table-column>
          <el-table-column
            width="200px"
            align="center"
            prop="create_at"
            label="创建时间"
          ></el-table-column>
        </el-table>
      </template>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageNumber"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
      <!-- 入库 -->
      <el-dialog
        :title="text"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible1"
        width="1100px"
        :before-close="handleClose1"
      >
        <div class="xian2"></div>
        <el-form
          ref="form1"
          :rules="rules1"
          :model="addform1"
          label-width="200px"
        >
           <el-form-item label="库位：" prop="ware">
            <el-select @change="int3" v-model="addform1.ware" placeholder="请选择">
              <el-option
                v-for="item in warehousekList"
                :key="item.id"
                :label="item.ware_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            
          </el-form-item>
          <el-form-item label="产品：" prop="product">
            <el-select @change="int4" v-model="addform1.product" placeholder="请选择">
              <el-option
                v-for="item in getProductList"
                :key="item.id"
                :label="item.product_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <span style="margin-left:20px;color:#999">请先选择库位</span>
          </el-form-item>
          <el-form-item label="实剩余：" prop="actual">
            <el-input class="int" v-model="addform1.actual"></el-input>
          </el-form-item>
         <el-form-item label="备注：">
              <el-input type="textarea" class="int" :autosize="{ minRows: 3}" v-model="addform1.remark"></el-input>
            </el-form-item>
        </el-form>
        <div class="btn_box">
          <el-button type="cha" class="add_btn111" @click="addRuku"
            >确定</el-button
          >
        </div>
      </el-dialog>
      
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      pageNumber: 5,
      name: '',
      product_name: '',
      userList: [],
      total: 0,
      tableHeader: {
        'background-color': '#EEF1F6',
        'border-top': '2px solid #1CA6C8',
        color: '#333',
      },
      

      // 使用配置参数
      dialogVisible1: false,
      addform1: {
        ware: '',
        product: '',
        actual: '',
        remark: ''
      },
      rules1: {
        ware: [
          { required: true, message: '请选择库位', trigger: 'blur' },
        ],
        product: [{ required: true, message: '请选择商品', trigger: 'blur' }],
        actual: [{ required: true, message: '请输入实剩余', trigger: 'blur' }]
      },
      text:'入库',
      //   产品列表
      getProductList: [],
    //   库位列表
    warehousekList: []
    }
  },
  created() {
    this.user()
  },
  methods: {
    handleSizeChange(val) {
      this.pageNumber = val
      this.user()
    },
    handleCurrentChange(val) {
      this.page = val
      this.user()
    },
    
    handleClose1() {
      this.dialogVisible1 = false
      this.$refs.form1.resetFields()
      this.addform = {
        product: '',
        num: '',
        start: '',
        end: '',
        ware: '',
        time: '',
        id: ''
      }
    },
    

    // 列表
    async user() {
      const { data: res } = await this.$http.get('api/wareCheck/index', {
        params: {
          page: this.page,
          pageNumber: this.pageNumber,
          name: this.name,
          product_name: this.product_name,
        },
      })
      console.log(11, res)
      this.userList = res.data.rows
      this.total = res.data.total
    },
    // 查询
    chaxun() {
      this.page = 1
      this.user()
    },
    
    // 点击添加
    add() {
      this.dialogVisible1 = true
      this.warehouse()
      this.text = '添加'
    },
    
    // 库位列表
    async warehouse() {
      const { data: res } = await this.$http.get('api/warehouse/index', {
        params: {
          page: 1,
          size: 200,
        },
      })
      console.log(11, res)
      this.warehousekList = res.data.rows
    },
    // 添加时根据仓库id获取产品列表
    async getProduct(id) {
      const { data: res } = await this.$http.get('api/wareCheck/getProduct', {
          params: {
              id: id
          }
      })
      console.log(11, res)
      this.getProductList = res.data
    },
    // 库位变化
    int3(ev) {
        this.getProduct(ev)
        this.addform1.product = ''
        if(this.addform1.ware && this.addform1.product) {
            this.wareCheck()
        }
    },
    // 产品变化
    int4() {
        if(this.addform1.ware && this.addform1.product) {
            this.wareCheck()
        }
    },
    // 添加时根据仓库和产品id获取剩余量
    async wareCheck() {
         const { data: res } = await this.$http.post('api/wareCheck/getMessage', 
       {
          product: this.addform1.product,
          ware: this.addform1.ware
        },
      )
      console.log(11, res)
       if (res.code != 200) return this.$message.error(res.msg)
      this.addform1.actual = res.data
    },
    // 添加
    addRuku() {
      this.$refs.form1.validate(async (valid) => {
        if (!valid) return this.$message.error('请填写完整的数据')

        const { data: res } = await this.$http.post(
          'api/wareCheck/saves',
          this.addform1
        )
        if (res.code != 200) return this.$message.error(res.msg)
        this.$message.success(res.msg)
        this.dialogVisible1 = false
        this.$refs.form1.resetFields()
        this.page = 1
        this.user()
      })
    }
  },
}
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  background-color: #fff;
  padding: 30px;
  box-sizing: border-box;
  margin-bottom: 20px;
  .tt {
    font-size: 24px;
  }
  .xian {
    width: 100%;
    height: 2px;
    background-color: #1ca6c8;
    margin: 30px auto;
  }
  .list_box {
    width: 100%;
    height: 60px;
    background-color: #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    box-sizing: border-box;
    .tt1 {
      font-size: 18px;
      padding: 4px 10px;
      border-left: 3px solid #1ca6c8;
    }
  }
  .int_box {
    padding: 25px 1px 0;
    display: flex;
    flex-wrap: wrap;
  }
  .int_box11 {
    display: flex;
    align-items: center;
    margin-bottom: 25px;
  }
  .int_width {
    width: 300px;
    margin-right: 40px;
  }
  .int_width1 {
    width: 300px;
  }
  span {
    color: #666;
  }
  .pagination {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 20px 0 10px;
  }
  .xian2 {
    width: 100%;
    height: 2px;
    background-color: #f0f0f0;
    margin-bottom: 20px;
  }
  .int {
    width: 400px;
  }

  .add_btn {
    margin-left: 800px;
  }
  .danger_btn {
    margin-left: 20px;
  }
  .btn_box {
    width: 100%;
    text-align: center;
    padding: 30px 0;
  }
  .add_btn111 {
    width: 140px;
  }
}
</style>
